// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2PDCd","label":"Labeled_label__yMCKF","divider":"Labeled_divider__2YBpc"};